import React from 'react'
import { Link } from "react-router-dom";


const SearchFilters = () => {
  return (
    <div className='flex gap-3'>
    <Link to='/genre'>
      <svg
        width="30"
        height="30"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.91675 8.75001C2.91675 7.13918 4.22258 5.83334 5.83341 5.83334H7.29175V29.1667H5.83341C4.22258 29.1667 2.91675 27.8609 2.91675 26.25V8.75001ZM23.3334 12.3958H17.5001C17.0974 12.3958 16.7709 12.7223 16.7709 13.125V14.5833C16.7709 14.986 17.0974 15.3125 17.5001 15.3125H23.3334C23.7361 15.3125 24.0626 14.986 24.0626 14.5833V13.125C24.0626 12.7223 23.7361 12.3958 23.3334 12.3958ZM9.47925 29.1667H29.1667C30.7776 29.1667 32.0834 27.8609 32.0834 26.25V8.75001C32.0834 7.13918 30.7776 5.83334 29.1667 5.83334H9.47925V29.1667ZM17.5001 10.2083H23.3334C24.9443 10.2083 26.2501 11.5142 26.2501 13.125V14.5833C26.2501 16.1942 24.9443 17.5 23.3334 17.5H17.5001C15.8892 17.5 14.5834 16.1942 14.5834 14.5833V13.125C14.5834 11.5142 15.8892 10.2083 17.5001 10.2083Z"
          fill="#333333"
        />
      </svg>
    </Link>
    <Link>
      <svg
        width="30"
        height="30"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.8915 20.417C27.7027 20.417 29.171 21.8852 29.171 23.6966V25.036C29.171 25.8722 28.9096 26.6874 28.4234 27.3677C26.1691 30.5223 22.4879 32.0852 17.4999 32.0852C12.511 32.0852 8.83165 30.5218 6.58267 27.3653C6.09855 26.6859 5.83838 25.8725 5.83838 25.0381V23.6966C5.83838 21.8852 7.3067 20.417 9.11798 20.417H25.8915ZM17.4999 2.9238C21.527 2.9238 24.7916 6.18839 24.7916 10.2155C24.7916 14.2426 21.527 17.5072 17.4999 17.5072C13.4728 17.5072 10.2082 14.2426 10.2082 10.2155C10.2082 6.18839 13.4728 2.9238 17.4999 2.9238Z"
          fill="#333333"
        />
      </svg>
    </Link>
  </div>
  )
}

export default SearchFilters